import React, { useState, useEffect } from 'react';
import { Block } from '../../../../../../../types/shared/blocksV3';
import FeetInchesInput from '../../FeetInchesInputV2';
import EdgeLabel from '../../../../../../../enums/edgeLabel';
import { Stack } from '@mui/material';

const BumpoutModal: React.FC<{
	block: Block;
	blockData?: Block;
	setBlockData?: (block: Block) => void;
}> = ({
	block,
	blockData: externalBlockData,
	setBlockData: externalSetBlockData,
}) => {
	const [internalBlockData, setInternalBlockData] = useState(block);
	const blockData = externalBlockData || internalBlockData;
	const setBlockData = externalSetBlockData || setInternalBlockData;

	useEffect(() => {
		setInternalBlockData(block);
	}, [block.id]);

	const handleWidthChange = (inches) => {
		setBlockData({
			...blockData,
			dimensions: {
				width: inches,
				depth: blockData.dimensions.depth,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width: inches,
				height: blockData.dimensions.depth,
			},
			edges: blockData.edges.map((edge) => {
				if (edge.label == EdgeLabel.TOP || edge.label == EdgeLabel.BOTTOM) {
					return {
						...edge,
						length: inches,
					};
				}
				return edge;
			}),
		});
	};

	const handleDepthChange = (inches) => {
		setBlockData({
			...blockData,
			dimensions: {
				width: blockData.dimensions.width,
				depth: inches,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width: blockData.dimensions.width,

				height: inches,
			},
			edges: blockData.edges.map((edge) => {
				if (edge.label == EdgeLabel.LEFT || edge.label == EdgeLabel.RIGHT) {
					return {
						...edge,
						length: inches,
					};
				}

				return edge;
			}),
		});
	};

	return (
		<Stack spacing={1.25}>
			<FeetInchesInput
				valueInches={blockData.dimensions.depth}
				labelInches="Depth"
				onChange={handleDepthChange}
			/>

			<FeetInchesInput
				valueInches={blockData.dimensions.width}
				labelInches="Width"
				onChange={handleWidthChange}
			/>
		</Stack>
	);
};

export default BumpoutModal;
